import { z } from '@fiverr-private/forms';
import { TranslationKeyWithPrefix, translate } from '../translate';

const MINIMAL_PASSWORD_LENGTH = 8;
const LOWERCASE_REGEX = /[a-z]+/;
const UPPERCASE_REGEX = /[A-Z]+/;
const DIGITS_REGEX = /\d+/;

const PASSWORD_ERROR_KEY = {
    MINIMAL_LENGTH: 'validation.password.minimal_length',
    MINIMAL_UPPERCASE_COUNT: 'validation.password.minimal_uppercase_count',
    MINIMAL_LOWERCASE_COUNT: 'validation.password.minimal_lowercase_count',
    MINIMAL_DIGITS_COUNT: 'validation.password.minimal_digits_count',
} satisfies Record<string, TranslationKeyWithPrefix>;

export const PASSWORD_ERROR_KEY_VALUES = Object.values(PASSWORD_ERROR_KEY);

export const newPasswordValidator = () =>
    z
        .string()
        .refine((value) => value.length >= MINIMAL_PASSWORD_LENGTH, {
            message: translate(PASSWORD_ERROR_KEY.MINIMAL_LENGTH),
            params: { errorKey: PASSWORD_ERROR_KEY.MINIMAL_LENGTH },
        })
        .refine((value) => LOWERCASE_REGEX.test(value), {
            message: translate(PASSWORD_ERROR_KEY.MINIMAL_LOWERCASE_COUNT),
            params: { errorKey: PASSWORD_ERROR_KEY.MINIMAL_LOWERCASE_COUNT },
        })
        .refine((value) => UPPERCASE_REGEX.test(value), {
            message: translate(PASSWORD_ERROR_KEY.MINIMAL_UPPERCASE_COUNT),
            params: { errorKey: PASSWORD_ERROR_KEY.MINIMAL_UPPERCASE_COUNT },
        })
        .refine((value) => DIGITS_REGEX.test(value), {
            message: translate(PASSWORD_ERROR_KEY.MINIMAL_DIGITS_COUNT),
            params: { errorKey: PASSWORD_ERROR_KEY.MINIMAL_DIGITS_COUNT },
        });
